import { ESRI_MAP_VIEW_ENTITY_ZOOM_LEVEL } from '../../esri/configurations';
import { useEsriMapViewRef } from './use-esri-map-view-ref';

/**
 * get the esri mapView object from useEsriMapViewRef(),
 * return m43 helpers/wrapper for mapView.
 */
export const useEsriMapView = () => {
    const esriMapViewRef = useEsriMapViewRef();

    const goTo = ({
        latitude,
        longitude,
        zoom = ESRI_MAP_VIEW_ENTITY_ZOOM_LEVEL,
    }: {
        latitude: number;
        longitude: number;
        zoom?: number;
    }) => {
        esriMapViewRef.current
            ?.goTo(
                {
                    center: [longitude, latitude],
                    zoom,
                },
                { animate: false }
            )
            .catch(() => {});
    };
    return { goTo };
};
